import React, { Component } from 'react';

class Typed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleChars: 1,
        }
        this.length = this.props.text.length || 0
    }
    increaseLength(){
        if(this.state.visibleChars < this.length && this.props.animate){
            this.setState({
                visibleChars: this.state.visibleChars + 1
            })
            this.timeout = setTimeout(() => {
                this.increaseLength()
            }, 50)
        }
    }
    componentDidMount() {
        this.increaseLength();
    }
    componentWillUnmount(){
        clearTimeout(this.timeout)
    }
    getText(){
        return this.props.animate ? this.props.text.slice(0, this.state.visibleChars) : this.props.text
    }
    render() {
        return <span>{ this.getText() }</span>
    }

}
export default Typed;